import React from 'react';
import './RadioInput.scss';

const RadioInput = (props) => {
  const { label, isDisabled, ariaLabel = 'radio', ...restProps } = props;
  return (
    <label
      className={`custom-generic-radio-button ${
        isDisabled ? 'disable-me' : ''
      }`}
    >
      <input {...restProps} type="radio" />
      <span
        className={isDisabled ? 'checkmark-disabled' : 'checkmark'}
        role="radio"
        aria-checked={restProps?.checked}
        aria-label={ariaLabel}
      ></span>
      <span className="custom-radio-button-label">{label}</span>
    </label>
  );
};

export default RadioInput;
